import CareerPlanningContent from './CareerPlanningContent'
export default CareerPlanningContent
